import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { IconCollection, Button } from '../../components';
import { AMENITY_OPTIONS } from '../../util/constant.js';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { Sheet } from 'react-modal-sheet';

// Reusable component for rendering amenities
const AmenitiesContent = ({ groupedCategories, grouped }) => {
  return (
    <>
      {groupedCategories.map(category => (
        <div key={category} className={css.amenitiesCategory}>
          <h3 className={css.amenitiesCategoryTitle}>{category}</h3>
          <div className={css.amenitiesItems}>
            {grouped[category].map(option => {
              const label = option?.label || option?.value || option?.key;
              const iconName = option?.iconName || 'amenity-default';
              const key = option?.value || option?.key || label;
              return (
                <div key={key} className={css.amenityItem}>
                  <span className={css.amenityIcon}>
                    <IconCollection iconName={iconName} />
                  </span>
                  <span className={css.amenityLabel}>{label}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

const SectionWhatsIncluded = props => {
  const { publicData } = props;
  const amenities = publicData?.amenities;
  const [showFullAmenities, setShowFullAmenities] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const selectedAmenities = Array.isArray(amenities) ? amenities : [];
  if (selectedAmenities.length === 0) {
    return null;
  }

  const optionsByValue = new Map();
  const categoryOrder = [];
  (Array.isArray(AMENITY_OPTIONS) ? AMENITY_OPTIONS : []).forEach(option => {
    const value = option?.value || option?.key;
    if (!value) return;
    optionsByValue.set(value, option);
    if (option?.category && !categoryOrder.includes(option.category)) {
      categoryOrder.push(option.category);
    }
  });

  const grouped = selectedAmenities.reduce((acc, value) => {
    const option = optionsByValue.get(value) || { label: value, value, category: 'Other' };
    const category = option.category || 'Other';
    const next = acc[category] ? [...acc[category], option] : [option];
    // eslint-disable-next-line no-param-reassign
    acc[category] = next;
    return acc;
  }, {});

  const groupedCategories = [...categoryOrder, 'Other'].filter(cat => grouped[cat]?.length);

  return (
    <div className={css.sectionWhatsIncluded}>
      <h2 className={css.sectionHeading}>
        <FormattedMessage id="ListingPage.whatsIncludedTitle" defaultMessage="What's Included" />
      </h2>
      <div
        className={classNames(
          css.amenitiesCategories,
          css.amenitiesContent,
          showFullAmenities ? css.expanded : css.collapsed
        )}
      >
        <AmenitiesContent groupedCategories={groupedCategories} grouped={grouped} />
      </div>

      <Sheet isOpen={openModal} onClose={() => setOpenModal(false)}>
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content>
            <div
              className={classNames(
                css.amenitiesCategories,
                css.amenitiesContent,
              )}
            >
              <AmenitiesContent groupedCategories={groupedCategories} grouped={grouped} />
            </div>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>


      <Button
        className={classNames(css.amentiesReadMoreButton, css.desktopBtn)}
        onClick={() => setShowFullAmenities(!showFullAmenities)}
      >
        {showFullAmenities ? (
          <FormattedMessage id="ListingPage.whatsIncluded.readLess" />
        ) : (
          <FormattedMessage id="ListingPage.whatsIncluded.readMore" />
        )}
      </Button>


      <Button onClick={() => setOpenModal(true)} className={classNames(css.amentiesReadMoreButton, css.mobileBtn)}>
        <FormattedMessage id="ListingPage.whatsIncluded.readMore" />
      </Button>
    </div>
  );
};

export default SectionWhatsIncluded;
